import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import { onAuthStateChanged, signInWithCustomToken } from 'firebase/auth';
import { auth } from '../firebase/firebase';

const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    window.history.replaceState({}, document.title, window.location.pathname);
    const success = params.get('success');
    const token = params.get('token');
    const error = params.get('error');

    const completeLogin = async () => {
      if (error || success !== 'true' || !token) {
        console.error('AFC user login callback rejected');
        message.error('Google login failed. Please try again.');
        navigate('/login', { replace: true });
        return;
      }

      try {
        const userCredential = await signInWithCustomToken(auth, token);
        const idToken = await userCredential.user.getIdToken();
        localStorage.setItem('authToken', idToken);
        await new Promise((resolve) => {
          if (auth.currentUser) {
            resolve();
            return;
          }
          let unsubscribe = () => {};
          const timeout = setTimeout(() => {
            unsubscribe();
            resolve();
          }, 3000);
          unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            if (!currentUser) return;
            clearTimeout(timeout);
            unsubscribe();
            resolve();
          });
        });

        const chatState = sessionStorage.getItem('chatState');
        if (chatState) {
          try {
            const { returnTo, draftCampaign } = JSON.parse(chatState);
            if (returnTo === 'chat-campaign-creation' && draftCampaign) {
              sessionStorage.setItem('preFillCampaign', JSON.stringify(draftCampaign));
              sessionStorage.removeItem('chatState');
              message.success('Logged in! Creating your campaign...');
              navigate('/campaigns?openModal=true', { replace: true });
              return;
            }
          } catch {
            sessionStorage.removeItem('chatState');
          }
        }

        console.log('AFC user login callback succeeded');
        message.success('Logged in successfully!');
        navigate('/dashboard', { replace: true });
      } catch {
        console.error('AFC user login callback failed');
        message.error('Google login failed. Please try again.');
        navigate('/login', { replace: true });
      }
    };

    completeLogin();
  }, [navigate]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: '#f0f2f5'
    }}>
      <p>Completing authentication…</p>
    </div>
  );
};

export default AuthCallback;
